import { Box, Typography } from '@mui/material'
import { NoDataIcon } from 'assets'
import React from 'react'
import { useTranslation } from 'react-i18next'

const NotFoundData = () => {

    const { t } = useTranslation()

    return (
        <Box sx={{
            flex: '1',
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%'
        }}
        >
            <NoDataIcon style={{ width: '150px', height: '150px' }} />
            <Typography sx={{ textAlign: 'center' }}>{t('search.notfound')}</Typography>
        </Box>
    )
}

export default NotFoundData